import { render, staticRenderFns } from "./CasinoIntegrationOption.vue?vue&type=template&id=ece0d1f0&scoped=true&"
import script from "./CasinoIntegrationOption.vue?vue&type=script&lang=js&"
export * from "./CasinoIntegrationOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece0d1f0",
  null
  
)

export default component.exports